import { ModalRoot, ModalContent } from './Modal.styled'

export const Modal = {
  Root: ModalRoot,
  Content: ModalContent,
}
